export enum LobbyFilterVariant {
    any = -1, // local only


    holdemGames = -2, // local only
    texasHoldEm = 1,
    texasHoldEmRock = 2, // (ring only)
    capTexasHoldEm = 3, // CAP, where CAP means max you can lose in a single hand. (ring only), (not limit only)

    omahaGames = -3, // local only
    omaha = 10,
    omahaHiLo = 11, /* Omaha with hi/lo winners */
    omaha5 = 12, /* Omaha with 5 cards instead of 4 */
    omaha5HiLo = 13, /* Omaha with 5 cards instead of 4 with hi/lo winners */
    capOmaha5HiLo = 30, // Omaha 5 Hi/Lo version that has CAP
    omaha6 = 14, /* Omaha with 6 cards instead of 4 */
    triOmaha = 15, // the combination will be from 3 cards, exactly 2 cards from player's 4 cards and only 1 from the table. so best combination is AAA
    capOmaha = 16, // Omaha with CAP, where CAP means max you can lose in a single hand, on all bet rounds. (ring only), (pot limit only)
    capOmaha5 = 22, // Omaha with CAP, where CAP means max you can lose in a single hand, on all bet rounds. (ring only), (pot limit only)
    capOmaha6 = 23, // Omaha with CAP, where CAP means max you can lose in a single hand, on all bet rounds. (ring only), (pot limit only)
    capOmaha7 = 27, // Omaha7 with CAP, where CAP means max you can lose in a single hand, on all bet rounds. (ring only), (pot limit only)
    omaha7 = 24, // Omaha with 7 cards instead of 4
    //
    _dramaha = 35, // Split pot game combination of Five-Card Draw and Pot-Limit Omaha
    _twoSevenDramaha = 36, // Similar to "Dramaha" but combination of Pot-Limit Omaha and 2-7 draw
    _dramadugi = 37, // Similar to "Dramaha" but combination of Pot-Limit Omaha and Badugi
    //
    _capDramaha = 38, // Dramaha with cap
    _capTwoSevenDramaha = 39, // 2-7 Dramaha with cap
    _capDramadugi = 40, // Dramadugi with cap

    drawGames = -5, // local only
    tripleDraw = 17, // 2/7 triple draw
    singleDraw = 29,

    capSingleDraw = 31, // 2-7 Single Draw CAP
    badugi = 18, // Badugi
    badeucey = 19, // Badeucey = mix of triple draw and badugi
    a5TripleDraw = 32, // A-5 Triple Draw
    badacey = 33,
    fiveCardDraw = 26, // Similar to triple draw but Hi
    //
    dramaha = 35, // Split pot game combination of Five-Card Draw and Pot-Limit Omaha
    twoSevenDramaha = 36, // Similar to "Dramaha" but combination of Pot-Limit Omaha and 2-7 draw
    dramadugi = 37, // Similar to "Dramaha" but combination of Pot-Limit Omaha and Badugi
    //
    capDramaha = 38, // Dramaha with cap
    capTwoSevenDramaha = 39, // 2-7 Dramaha with cap
    capDramadugi = 40, // Dramadugi with cap

    studGames = -4, // local only

    sevenStud = 20, // player receives 7 cards, 2 face down - private, 4 face up - everyone can see, and 7th card face down - private, no public/community cards. (Fix limit only. and has ante)
    sevenStudHiLo = 21, // hybrid of 7 stud and Omaha hi/lo
    razz = 25, // Form of 7 stud game but the lowest possible five-card hand is winner
    twoSevenRazz = 34,

    mixTable = 100 // the variant is changing every hand and sent by the server.
}
